class MainSearch extends SearchForm {
}

customElements.define("main-search", MainSearch);

// DEV NOTE: Removed global search input syncing.
// Each search box must keep its own value; resetting one search form
// must not clear or affect other search inputs.